export default __webpack_public_path__ + "static/media/company_logo.e8efaedb.png";